import tableSection from "../../components/tableSection/index.vue";

export default {
    name: "tablePage",
    components: {
        tableSection
    },
    methods: {}
};